<template>
    <div v-if="uiStore.siteName == 'thedrakeinn'" style="height:25px;" class="d-flex">
        <the-drake-inn-text-logo />
    </div>
    <stay-marquis-logo v-else />
</template>

<script type="text/javascript">
    import StayMarquisLogo from '@/assets/logos/staymarquis.svg.vue';
    import TheDrakeInnTextLogo from '@/assets/logos/the-drake-inn-text.svg.vue';

    import { UseUIStore } from '@/store/UI.js';

    export default {

        components: {
            TheDrakeInnTextLogo,
            StayMarquisLogo,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },
        
    };

</script>